import axiosInstance from "../instance/axiosInstance";

class UsersApi {
  static async completeProfile(formData) {
    try {
      const response = await axiosInstance.post(`/four-step-form`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async changePassword(formData) {
    try {
      const response = await axiosInstance.post(`/password-update`, formData);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getAvailability() {
    try {
      const response = await axiosInstance.get(`/availability`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async saveAvailability(payload) {
    try {
      const response = await axiosInstance.post(`/availability`, payload);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getCitiesList() {
    try {
      const response = await axiosInstance.get(`/getCities`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getProvincesList() {
    try {
      const response = await axiosInstance.get(`/getProvinces`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getPlatform() {
    try {
      const response = await axiosInstance.get(`/getPlatforms`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default UsersApi;
